function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.128 0h29.744c1.783 0 2.43.186 3.082.534.652.349 1.163.86 1.512 1.512.348.652.534 1.299.534 3.082v29.744c0 1.783-.186 2.43-.534 3.082a3.635 3.635 0 0 1-1.512 1.512c-.652.348-1.299.534-3.082.534H5.128c-1.783 0-2.43-.186-3.082-.534a3.635 3.635 0 0 1-1.512-1.512C.186 37.302 0 36.655 0 34.872V5.128c0-1.783.186-2.43.534-3.082A3.635 3.635 0 0 1 2.046.534C2.698.186 3.345 0 5.128 0z",
  fill: "#A7F0BA"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#24A148"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 27h-2V13h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4v5zm0-7h4v-5h-4v5zM17 27h-6v-2h6v-4h-6v-8h8v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z"
})));
const Svg5P40 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg5P40, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/5-p-40.ae51575b.svg";
export { ForwardRef as ReactComponent };